import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import useWallet from "../utils/hooks/useWalletConnect";
import { copyIcon } from "./SVG";
import useSignature from "../utils/hooks/useSignature";
import { useDispatch } from "react-redux";
import { setSignature } from "../redux/user/action";

export default function Header() {
  const { isConnected, account, connectWallet, disconnect } = useWallet();
  const { isSignIn, generateSignature } = useSignature();
  const dispatch = useDispatch();
  const [menu, setMenu] = useState(false);
  const location = useLocation();
  const closeFunc = (e) => {
    if (e.target === e.currentTarget) setMenu(false);
  };

  useEffect(() => {
    if (menu) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [menu]);

  useEffect(() => {
    setMenu(false);
    document.body.classList.remove("active");
  }, [location]);

  const handleCopyAddress = () => {
    if (account) {
      navigator.clipboard.writeText(account);
    }
  };
  const shortenAddress = (address) => {
    const firstFive = address?.substring(0, 5);
    const lastFive = address?.substring(address.length - 5);
    return `${firstFive}...${lastFive}`;
  };

  const walletBtn = () => {
    if (isConnected && isSignIn) {
      return (
        <div style={{display:'flex'}}>
   

          <div className="address-container" onClick={handleCopyAddress}>
            <div className="address">{shortenAddress(account)}</div>
            {copyIcon}
          </div>
          <div
            className="disconnect"
            onClick={() => {
              localStorage.removeItem("signature");
              dispatch(setSignature(""));
              disconnect();
            }}
          >
           Disconnect
          </div>
        </div>
      );
    } else if (isConnected && !isSignIn) {
      return (
        <button onClick={generateSignature} className="button connect">
          Connect Wallet
        </button>
      );
    } else {
      return (
        <button onClick={connectWallet} className="button connect">
          Connect Wallet
        </button>
      );
    }
  };

  return (
    <div className="header">
      <div className="auto__container">
        <div className="header__inner">
          <Link to="" className="header__inner-logo">
            <img src={process.env.PUBLIC_URL + "/images/logo.svg"} alt="logo" />
          </Link>
          <nav className={"nav " + (menu ? "active" : "")} onClick={closeFunc}>
            <div className="nav__inner">
              <NavLink to="/" className="nav__inner-link">
                Dashboard
              </NavLink>
              {/* <NavLink to="dashboard/rewards" className="nav__inner-link">
                Rewards
              </NavLink> */}
              <NavLink to="dashboard/wallets" className="nav__inner-link">
                Wallets
              </NavLink>
              <NavLink to="dashboard/profile" className="nav__inner-link">
                Profile
              </NavLink>
              <NavLink to="dashboard/guides" className="nav__inner-link">
                Guides
              </NavLink>
            </div>
          </nav>
          {/* {isConnected ? (
            <div className="address-container" onClick={handleCopyAddress}>
              <div className="address">{shortenAddress(account)}</div>
              {copyIcon}
            </div>
          ) : (
            <button onClick={connectWallet} className="button connect">
              Connect Wallet
            </button>
          )} */}
          {walletBtn()}

          <div
            className={"burger " + (menu ? "active" : "")}
            onClick={() => setMenu(!menu)}
          >
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}
